import { getRegisteredRum } from '@codametrix/client-registry';
import type { CmxRumApi } from './rum-api';

const stubRUM: CmxRumApi = {
  startView: () => {},
  addAction: () => {},
  addError: () => {},
  setUser: () => {},
  setUserProperty: () => {},
  clearGlobalContext: () => {},
  setGlobalContextProperty: () => {},
  getGlobalContext: () => ({}),
};

export function getRUM(): CmxRumApi {
  const fromRegistry = getRegisteredRum<CmxRumApi>();
  if (fromRegistry) {
    return fromRegistry;
  }
  // Transitional fallback while bootstrap still assigns window.DD_RUM and
  // legacy call sites have not all migrated to getRUM()/registerRum.
  const rum = (window as Window & { DD_RUM?: CmxRumApi }).DD_RUM;
  return rum ?? stubRUM;
}
